import script from "./StorageCostWorkbench.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageCostWorkbench.vue?vue&type=script&setup=true&lang=js"

import "./StorageCostWorkbench.vue?vue&type=style&index=0&id=30831194&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30831194"]])

export default __exports__